import { memo } from 'react';
import { useResponsive } from 'app/hooks';
import {
  HStack,
  Media,
  Text,
  VStack,
} from 'app/pages/request-single-page/components-v4';
import { ThumbnailsControls } from '../thumbnails-controls';

export const FilesList = memo(() => {
  const { device } = useResponsive();
  const showControls = !(device.phone || device.tablet || device.touch);

  return (
    <VStack spacing="xs">
      <HStack align="center" justify="space-between">
        <Text variant="heading-4" color="gray.500">
          Вложения
        </Text>

        {showControls && <ThumbnailsControls />}
      </HStack>

      <Media.Thumbnails aspectRatio="3:4" viewMode="carousel" />
    </VStack>
  );
});
